module.exports = __webpack_public_path__ + "static/IMG_17700-68871fa5e085d8cc933bc43ee57933c9.jpg";